var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { UIComponent, childrenExist, customPropTypes, commonPropTypes, } from '../../lib';
import { defaultBehavior } from '../../lib/accessibility';
/**
 * A grid is used to harmonize negative space in a layout.
 * @accessibility This is example usage of the accessibility tag.
 * This should be replaced with the actual description after the PR is merged
 */
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content;
        return (React.createElement(ElementType, __assign({ className: classes.root }, rest), childrenExist(children) ? children : content));
    };
    Grid.displayName = 'Grid';
    Grid.className = 'ui-grid';
    Grid.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.func, columns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), content: customPropTypes.every([
            customPropTypes.disallow(['children']),
            PropTypes.oneOfType([
                PropTypes.arrayOf(customPropTypes.nodeContent),
                customPropTypes.nodeContent,
            ]),
        ]), rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) });
    Grid.defaultProps = {
        as: 'div',
        accessibility: defaultBehavior,
    };
    return Grid;
}(UIComponent));
export default Grid;
